'use strict';
//objectEvent
export default class ObjectEventComponent {
  constructor() {
    this.restrict = 'A'
    this.template = require('./object.event.component.html');
    this.scope = {
      alarmObject: '=',
      event: '=',
      isEditable: '='
    };
    this.controller = ObjectEventComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

/* @ngInject */
class ObjectEventComponentController {
  constructor($scope) {
    this.$scope = $scope;

    /**
     * Init data changed
     */
    this.$scope.$watch('ctrl.event', () => {
      this.start = new Date(this.event.start);
      this.end = new Date(this.event.end);
      this.endIsValid = this.event.end > this.event.start;
    });
  }

  update() {
    this.event.start = this.start.getTime();
    this.event.end = this.end.getTime();

    this.endIsValid = this.event.end > this.event.start;

  }

  /**
   * Delete existing event
   * @param {*} event 
   */
  delete(event) {
    this.alarmObject.events.splice(this.alarmObject.events.indexOf(event), 1);
  };

}
